import { Select, SelectProps } from '@chakra-ui/react';

interface CustomOptionSelectorProps extends SelectProps {
  options: string[] | number[];
  selectedOption: string | number;
  setSelectedOption: (option: string | number) => void;
  labels?: string[];
  size?: 'small' | 'medium' | 'large' | 'large-unrounded';
}

export default function CustomOptionSelectorSelectComponent({
  options,
  selectedOption,
  setSelectedOption,
  labels,
  size = 'small',
  ...rest
}: CustomOptionSelectorProps) {
  let height, borderRadius, fontSize;

  if (size === 'small') {
    height = '24px';
    borderRadius = '12.5px';
    fontSize = '12px';
  } else if (size === 'medium') {
    height = '38px';
    borderRadius = '24.5px';
    fontSize = '12px';
  } else if (size === 'large') {
    height = '44px';
    borderRadius = '44px';
    fontSize = '14px';
  } else if (size === 'large-unrounded') {
    height = '38px';
    borderRadius = '8px';
    fontSize = '14px';
  }

  return (
    <Select
      borderColor="#e0e3e6"
      color="gray.200"
      maxWidth="max-content"
      minH={height}
      h={height}
      sx={{
        ':focus': {
          fontSize,
          borderRadius,
        },
        ':not(:placeholder-shown)': {
          fontSize,
          borderRadius,
          padding: '0 35px 0 15px',
        },
        ':not(:focus)': {
          borderRadius,
        },
      }}
      textTransform="capitalize"
      onChange={(e) => setSelectedOption(e.target.value)}
      {...rest}
    >
      {options.map((option, index) => (
        <option key={index} value={option}>
          {labels?.[index] ?? option}
        </option>
      ))}
    </Select>
  );
}
